//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductBaseView',
  props: {
    product: {
      default: () => { },
    },
    price: {
      default: '0.00',
    },
    isSale: {
      default: () => false,
    },
    load: {},
    disabled: {
      default: () => false,
    },
    canRemove: {
      default: () => false,
    },
  },
  data() {
    return {
      currency: window.currency,
    }
  },
  computed: {
    inStock() {
      const p = this.product.element.props;
      return 'available' === p.availability_status &&
          (!p.track_inventory || (p.track_inventory && p.stock_quantity));
    },

    getPercent() {
      return (oldPrice, newPrice) => {
        if (!oldPrice || !newPrice) return 0;
        const percent = ((oldPrice - newPrice) / oldPrice) * 100;
        return Math.round(percent);
      }
    },

    onOrder() {
      const p = this.product.element.props;
      return 'confirmation_of_availability' === p.availability_status &&
          (!p.track_inventory || (p.track_inventory && p.stock_quantity));
    },

    notAvailable() {
      const p = this.product.element.props;
      const hasStock = !p.track_inventory || (p.track_inventory && p.stock_quantity);

      return !(
        'available' === p.availability_status ||
          ('confirmation_of_availability' === p.availability_status && hasStock)
      );
    },
    canChange() {
      // fix me
      return !this.disabled || !this.canRemove || !this.isSale
    },
    // inStock() {
    //   return 'available' === this.product.element.props.availability_status || 'confirmation_of_availability' === this.product.element.props.availability_status &&
    //     (!this.product.element.props.track_inventory || this.product.element.props.track_inventory && this.product.element.props.stock_quantity)
    // },
  },
}
